import { BfiApi } from '@apply/api';

interface PasswordResetDirectionsProps {
    failureResult?: BfiApi.IChangePasswordResult;
}

export const PasswordResetDirections: React.FC<PasswordResetDirectionsProps> = ({ failureResult }) => {
    const passwordNotSubmitted =
        !failureResult?.succeeded &&
        !failureResult?.passwordTooShort &&
        !failureResult?.passwordRequiresSpecialCharacter &&
        !failureResult?.passwordRequiresDigit &&
        !failureResult?.passwordRequiresMixedCase;

    const directionsMessage = () => {
        if (failureResult == undefined || passwordNotSubmitted || failureResult?.succeeded) {
            return 'To update your password it must meet the following criteria:';
        } else {
            return (
                <>
                    Your password failed to meet the requirements indicated in <span style={{ color: 'red' }}>red</span> below...
                </>
            );
        }
    };

    const statusIndicatorMessage = () => {
        if (failureResult?.succeeded) {
            return (
                <>
                    <div style={{ paddingTop: '20px' }}>
                        Your password was <span style={{ color: 'green' }}>successfully</span> updated.
                    </div>
                </>
            );
        }
    };

    return (
        <>
            <div className='brokerSettingsPasswordResetDirections'>
                {directionsMessage()}
                <div className='brokerSettingsPasswordResetDirections-list'>
                    <ul>
                        <li
                            style={{
                                color: failureResult?.passwordTooShort ? 'red' : 'inherit',
                            }}
                        >
                            At least 8 characters
                        </li>
                        <li
                            style={{
                                color: failureResult?.passwordRequiresMixedCase ? 'red' : 'inherit',
                            }}
                        >
                            A mixture of both uppercase and lowercase letters
                        </li>
                        <li
                            style={{
                                color: failureResult?.passwordRequiresDigit ? 'red' : 'inherit',
                            }}
                        >
                            A mixture of letters and numbers
                        </li>
                        <li
                            style={{
                                color: failureResult?.passwordRequiresSpecialCharacter ? 'red' : 'inherit',
                            }}
                        >
                            Inclusion of at least one special character, e.g., ! @ # ? ]
                        </li>
                    </ul>
                </div>
                {statusIndicatorMessage()}
            </div>
        </>
    );
};
